<template>
  <div class="rodo-regulation">
    <p v-html="preamble" />
    <ol v-if="expanded">
      <li v-for="(item, index) in body" :key="index" v-html="item" />
    </ol>
    <button role="button" v-if="!expanded" @click.prevent="expand">rozwiń</button>
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  props: {
    preamble: {
      type: String,
      required: true,
    },
    body: {
      type: Array,
      required: true,
    },
  },
})
export default class RodoRegulations extends Vue {
  expanded = false

  expand () {
    this.expanded = true
  }
}
</script>

<style lang="scss">
.rodo-regulation {
  color: #535353;
  line-height: 18px;
  font-size: 10px;
  font-family: 'Gotham Book';

  button {
    background-color: transparent;
    border: none;
    display: flex;
    justify-content: center;
    width: auto;
    margin: auto;
    padding: 0;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/forms/RodoRegulations.vue